import type { TDeepthLevelStack } from '@/components/organisms/Form/Validator';
import { formatValueDestination } from '@/components/organisms/Form/Validator/utils/format-value-destination';
import { useMemo } from 'react';
import type { TUIElement } from '@ballerine/common';

export const useValueDestination = (element: TUIElement, stack: TDeepthLevelStack = []) => {
  const valueDestination = useMemo(() => {
    if (!element.valueDestination) {
      return undefined;
    }

    return formatValueDestination(element.valueDestination, stack);
  }, [element.valueDestination, stack]);

  return valueDestination;
};
